import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { CategoryTermsQuery } from '@custom/schema';

export const useCategoryTermsQuery = () =>
  useStaticQuery(graphql(CategoryTermsQuery));
